<template>
    <div class="about-header">
        <div class="about-header__content">
            <h2 class="about-header__title">关于</h2>
        </div>
        <div class="about-header__banner">
            <img src="http://cdn.airfunc.com/undraw_working_from_anywhere_ub67.svg">
        </div>
    </div>
</template>

<script>
    export default {
        name: "AboutHeader"
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .about-header {
        display: flex;
        margin-bottom: $paddingMD;
        flex-direction: column-reverse;


        &__content {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding-right: 0;
            text-align: center;
            justify-content: center;
        }

        &__title {
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSizeLG;
            font-weight: $fontWeightBold;
            @include transition-colors;
        }

        &__banner {
            width: 60%;
            margin: 0 auto $paddingMD;
            display: flex;
            align-items: flex-end;
        }

    }

    @media (min-width: 1024px) {
        .about-header {
            flex-direction: row;
            &__content {
                width: 70%;
                padding-right: $paddingMD;
                text-align: left;
            }

            &__banner {
                width: 30%;
                margin: 0;
            }
        }
    }
</style>